
import * as Styled from './AppLoaderStyles';
import {Spinner} from 'react-bootstrap';

const AppLoader = () => {

  return (
    <Styled.Container>
      <Spinner animation="border" className="trova-color" />
    </Styled.Container>
  )
}

export default AppLoader;